export const APP_DEFAULT_LOCALE = process.env.REACT_APP_DEFAULT_LOCALE;
export const APP_PROTOCOL = process.env.REACT_APP_PROTOCOL;
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN;
export const APP_BASEPATH = `${APP_PROTOCOL}://${APP_DOMAIN}`;
export const APP_HTML_DATE_FORMAT = "YYYY-MM-DD";
export const APP_HTML_TIME_FORMAT = "HH:mm:ss";
export const APP_HTML_DATEANDTIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const APP_DATE_FORMAT = "DD/MM/YYYY";
export const APP_TIME_FORMAT = "HH:mm";
export const APP_DATEANDTIME_FORMAT = "DD/MM/YYYY HH:mm";
export const APP_DP_DATE_FORMAT = "dd/MM/yyyy";
export const APP_DP_TIME_FORMAT = "HH:mm";
export const APP_DP_DATEANDTIME_FORMAT = "dd/MM/yyyy HH:mm";
export const PAGE_SIZE = 10;
export const PAGE_SIZES = [10, 30, 50, 100];
export const FORM_CONTAINER = "drawer";

export const FE = {
    InternshipSchedule: {
        BREAK_DURATION: [0, 15, 30, 45, 60, 90],
    },
    ViewType: {
        VIEW_TYPE_LIST: "LIST",
        VIEW_TYPE_MAP: "MAP",
        VIEW_TYPE_CALENDAR: "CALENDAR",
    },
};

export const BE = {
    User: {
        // ROLE: {
        //     ROLE_SUPER_ADMIN: "ROLE_SUPER_ADMIN",
        //     ROLE_INTERNSHIP_COORDINATOR_TRAINER:
        //         "ROLE_INTERNSHIP_COORDINATOR_TRAINER",
        //     ROLE_INTERNSHIP_REFERENCE_TRAINER:
        //         "ROLE_INTERNSHIP_REFERENCE_TRAINER",
        //     ROLE_PEDAGOGICAL_REFERENCE_TRAINER:
        //         "ROLE_PEDAGOGICAL_REFERENCE_TRAINER",
        //     ROLE_SCHOOL_DIRECTOR: "ROLE_SCHOOL_DIRECTOR",
        //     ROLE_STUDENT: "ROLE_STUDENT",
        //     ROLE_INTERNSHIP_COORDINATOR: "ROLE_INTERNSHIP_COORDINATOR",
        //     ROLE_INTERNSHIP_SUPERVISOR: "ROLE_INTERNSHIP_SUPERVISOR",
        //     ROLE_INTERNSHIP_TUTOR: "ROLE_INTERNSHIP_TUTOR",
        //     ROLE_COMPANY_DIRECTOR: "ROLE_COMPANY_DIRECTOR",
        //     ROLE_SCHOOL_AND_COMPANY: "ROLE_SCHOOL_AND_COMPANY",
        // },
        NATIONALITY: {
            NATIONALITY_AFGHAN: "Afghane",
            NATIONALITY_SOUTH_AFRICAN: "Sud-africaine",
            NATIONALITY_ALBANIAN: "Albanaise",
            NATIONALITY_ALGERIAN: "Algérienne",
            NATIONALITY_GERMAN: "Allemande",
            NATIONALITY_ANDORRAN: "Andorrane",
            NATIONALITY_ANGOLAN: "Angolaise",
            NATIONALITY_ANTIGUAN_AND_BARBUDA: "Antiguaise-et-barbudienne",
            NATIONALITY_SAUDI: "Saoudienne",
            NATIONALITY_ARGENTINIAN: "Argentine",
            NATIONALITY_ARMENIAN: "Arménienne",
            NATIONALITY_AUSTRALIAN: "Australienne",
            NATIONALITY_AUSTRIAN: "Autrichienne",
            NATIONALITY_AZERBAIJANI: "Azerbaïdjanaise",
            NATIONALITY_BAHAMIAN: "Bahamienne",
            NATIONALITY_BAHRAINI: "Bahreïnienne",
            NATIONALITY_BANGLADESHI: "Bangladaise",
            NATIONALITY_BARBADIAN: "Barbadienne",
            NATIONALITY_BELGIAN: "Belge",
            NATIONALITY_BELIZEAN: "Bélizienne",
            NATIONALITY_BENINESE: "Béninoise",
            NATIONALITY_BHUTANESE: "Bhoutanaise",
            NATIONALITY_BELARUSIAN: "Biélorusse",
            NATIONALITY_BURMESE: "Birmane",
            NATIONALITY_BOLIVIAN: "Bolivienne",
            NATIONALITY_BOSNIAN: "Bosnienne",
            NATIONALITY_BOTSWANAN: "Botswanaise",
            NATIONALITY_BRAZILIAN: "Brésilienne",
            NATIONALITY_BRUNEIAN: "Brunéienne",
            NATIONALITY_BULGARIAN: "Bulgare",
            NATIONALITY_BURKINABE: "Burkinabè",
            NATIONALITY_BURUNDIAN: "Burundaise",
            NATIONALITY_CAMBODIAN: "Cambodgienne",
            NATIONALITY_CAMEROONIAN: "Camerounaise",
            NATIONALITY_CANADIAN: "Canadienne",
            NATIONALITY_CAPE_VERDEAN: "Cap-verdienne",
            NATIONALITY_CENTRAL_AFRICAN: "Centrafricaine",
            NATIONALITY_CHILEAN: "Chilienne",
            NATIONALITY_CHINESE: "Chinoise",
            NATIONALITY_CYPRIOT: "Chypriote",
            NATIONALITY_COLOMBIAN: "Colombienne",
            NATIONALITY_COMORAN: "Comorienne",
            NATIONALITY_CONGOLESE: "Congolaise (République du Congo)",
            NATIONALITY_CONGOLESE_DRC:
                "Congolaise (République démocratique du Congo)",
            NATIONALITY_NORTH_KOREAN: "Nord-coréenne",
            NATIONALITY_SOUTH_KOREAN: "Sud-coréenne",
            NATIONALITY_COSTA_RICAN: "Costaricienne",
            NATIONALITY_IVORIAN: "Ivoirienne",
            NATIONALITY_CROATIAN: "Croate",
            NATIONALITY_CUBAN: "Cubaine",
            NATIONALITY_DANISH: "Danoise",
            NATIONALITY_DJIBOUTIAN: "Djiboutienne",
            NATIONALITY_DOMINICAN_DOMINICA: "Dominiquaise",
            NATIONALITY_DOMINICAN_REPUBLIC: "Dominicaine",
            NATIONALITY_EGYPTIAN: "Égyptienne",
            NATIONALITY_EMIRATI: "Émiratie",
            NATIONALITY_ECUADORIAN: "Équatorienne",
            NATIONALITY_ERITREAN: "Érythréenne",
            NATIONALITY_SPANISH: "Espagnole",
            NATIONALITY_ESTONIAN: "Estonienne",
            NATIONALITY_ESWATINI: "Eswatinienne",
            NATIONALITY_ETHIOPIAN: "Éthiopienne",
            NATIONALITY_FIJIAN: "Fidjienne",
            NATIONALITY_FINNISH: "Finlandaise",
            NATIONALITY_FRENCH: "Française",
            NATIONALITY_GABONESE: "Gabonaise",
            NATIONALITY_GAMBIAN: "Gambienne",
            NATIONALITY_GEORGIAN: "Géorgienne",
            NATIONALITY_GHANAIAN: "Ghanéenne",
            NATIONALITY_GREEK: "Grecque",
            NATIONALITY_GRENADIAN: "Grenadienne",
            NATIONALITY_GUATEMALAN: "Guatémaltèque",
            NATIONALITY_GUINEAN: "Guinéenne",
            NATIONALITY_GUINEA_BISSAU: "Bissau-guinéenne",
            NATIONALITY_EQUATORIAL_GUINEAN: "Équato-guinéenne",
            NATIONALITY_GUYANESE: "Guyanienne",
            NATIONALITY_HAITIAN: "Haïtienne",
            NATIONALITY_HONDURAN: "Hondurienne",
            NATIONALITY_HUNGARIAN: "Hongroise",
            NATIONALITY_INDIAN: "Indienne",
            NATIONALITY_INDONESIAN: "Indonésienne",
            NATIONALITY_IRAQI: "Irakienne",
            NATIONALITY_IRANIAN: "Iranienne",
            NATIONALITY_IRISH: "Irlandaise",
            NATIONALITY_ICELANDIC: "Islandaise",
            NATIONALITY_ISRAELI: "Israélienne",
            NATIONALITY_ITALIAN: "Italienne",
            NATIONALITY_JAMAICAN: "Jamaïcaine",
            NATIONALITY_JAPANESE: "Japonaise",
            NATIONALITY_JORDANIAN: "Jordanienne",
            NATIONALITY_KAZAKHSTANI: "Kazakhstanaise",
            NATIONALITY_KENYAN: "Kényane",
            NATIONALITY_KYRGYZ: "Kirghize",
            NATIONALITY_KIRIBATI: "Kiribatienne",
            NATIONALITY_KUWAITI: "Koweïtienne",
            NATIONALITY_LAOTIAN: "Laotienne",
            NATIONALITY_LESOTHO: "Lesothane",
            NATIONALITY_LATVIAN: "Lettone",
            NATIONALITY_LEBANESE: "Libanaise",
            NATIONALITY_LIBERIAN: "Libérienne",
            NATIONALITY_LIBYAN: "Libyenne",
            NATIONALITY_LIECHTENSTEIN: "Liechtensteinoise",
            NATIONALITY_LITHUANIAN: "Lituanienne",
            NATIONALITY_LUXEMBOURGISH: "Luxembourgeoise",
            NATIONALITY_MACEDONIAN: "Macédonienne",
            NATIONALITY_MALAGASY: "Malgache",
            NATIONALITY_MALAYSIAN: "Malaisienne",
            NATIONALITY_MALAWIAN: "Malawienne",
            NATIONALITY_MALDIVIAN: "Maldivienne",
            NATIONALITY_MALIAN: "Malienne",
            NATIONALITY_MALTESE: "Maltaise",
            NATIONALITY_MOROCCAN: "Marocaine",
            NATIONALITY_MARSHALLESE: "Marshallaise",
            NATIONALITY_MAURITIAN: "Mauricienne",
            NATIONALITY_MAURITANIAN: "Mauritanienne",
            NATIONALITY_MEXICAN: "Mexicaine",
            NATIONALITY_MICRONESIAN: "Micronésienne",
            NATIONALITY_MOLDOVAN: "Moldave",
            NATIONALITY_MONEGASQUE: "Monégasque",
            NATIONALITY_MONGOLIAN: "Mongole",
            NATIONALITY_MONTENEGRIN: "Monténégrine",
            NATIONALITY_MOZAMBICAN: "Mozambicaine",
            NATIONALITY_NAMIBIAN: "Namibienne",
            NATIONALITY_NAURUAN: "Nauruane",
            NATIONALITY_NEPALI: "Népalaise",
            NATIONALITY_NICARAGUAN: "Nicaraguayenne",
            NATIONALITY_NIGERIEN: "Nigérienne",
            NATIONALITY_NIGERIAN: "Nigériane",
            NATIONALITY_NORWEGIAN: "Norvégienne",
            NATIONALITY_NEW_ZEALANDER: "Néo-zélandaise",
            NATIONALITY_OMANI: "Omanaise",
            NATIONALITY_UGANDAN: "Ougandaise",
            NATIONALITY_UZBEK: "Ouzbèke",
            NATIONALITY_PAKISTANI: "Pakistanaise",
            NATIONALITY_PALAUAN: "Palaosienne",
            NATIONALITY_PALESTINIAN: "Palestinienne",
            NATIONALITY_PANAMANIAN: "Panaméenne",
            NATIONALITY_PAPUA_NEW_GUINEAN: "Papouane-néo-guinéenne",
            NATIONALITY_PARAGUAYAN: "Paraguayenne",
            NATIONALITY_DUTCH: "Néerlandaise",
            NATIONALITY_PERUVIAN: "Péruvienne",
            NATIONALITY_FILIPINO: "Philippine",
            NATIONALITY_POLISH: "Polonaise",
            NATIONALITY_PORTUGUESE: "Portugaise",
            NATIONALITY_QATARI: "Qatarienne",
            NATIONALITY_ROMANIAN: "Roumaine",
            NATIONALITY_BRITISH: "Britannique",
            NATIONALITY_RUSSIAN: "Russe",
            NATIONALITY_RWANDAN: "Rwandaise",
            NATIONALITY_KITTIAN_NEVISIAN: "Saint-Christophienne-et-Névicienne",
            NATIONALITY_SAINT_LUCIAN: "Saint-Lucienne",
            NATIONALITY_SAN_MARINESE: "Saint-Marinaise",
            NATIONALITY_VINCENTIAN: "Saint-Vincentaise-et-Grenadine",
            NATIONALITY_SOLOMON_ISLANDER: "Salomonaise",
            NATIONALITY_SALVADORAN: "Salvadorienne",
            NATIONALITY_SAMOAN: "Samoane",
            NATIONALITY_SAO_TOMEAN: "Santoméenne",
            NATIONALITY_SENEGALESE: "Sénégalaise",
            NATIONALITY_SERBIAN: "Serbe",
            NATIONALITY_SEYCHELLOIS: "Seychelloise",
            NATIONALITY_SIERRA_LEONEAN: "Sierra-léonaise",
            NATIONALITY_SINGAPOREAN: "Singapourienne",
            NATIONALITY_SLOVAK: "Slovaque",
            NATIONALITY_SLOVENIAN: "Slovène",
            NATIONALITY_SOMALI: "Somalienne",
            NATIONALITY_SUDANESE: "Soudanaise",
            NATIONALITY_SOUTH_SUDANESE: "Sud-soudanaise",
            NATIONALITY_SRI_LANKAN: "Sri-lankaise",
            NATIONALITY_SWEDISH: "Suédoise",
            NATIONALITY_SWISS: "Suisse",
            NATIONALITY_SURINAMESE: "Surinamaise",
            NATIONALITY_SYRIAN: "Syrienne",
            NATIONALITY_TAJIK: "Tadjike",
            NATIONALITY_TANZANIAN: "Tanzanienne",
            NATIONALITY_CHADIAN: "Tchadienne",
            NATIONALITY_CZECH: "Tchèque",
            NATIONALITY_THAI: "Thaïlandaise",
            NATIONALITY_TIMORESE: "Timoraise",
            NATIONALITY_TOGOLESE: "Togolaise",
            NATIONALITY_TONGAN: "Tongienne",
            NATIONALITY_TRINIDADIAN: "Trinidadienne",
            NATIONALITY_TUNISIAN: "Tunisienne",
            NATIONALITY_TURKMEN: "Turkmène",
            NATIONALITY_TURKISH: "Turque",
            NATIONALITY_TUVALUAN: "Tuvaluane",
            NATIONALITY_UKRAINIAN: "Ukrainienne",
            NATIONALITY_URUGUAYAN: "Uruguayenne",
            NATIONALITY_AMERICAN: "Américaine",
            NATIONALITY_VANUATUAN: "Vanuatuane",
            NATIONALITY_VATICAN: "Vaticane",
            NATIONALITY_VENEZUELAN: "Vénézuélienne",
            NATIONALITY_VIETNAMESE: "Vietnamienne",
            NATIONALITY_YEMENI: "Yéménite",
            NATIONALITY_ZAMBIAN: "Zambienne",
            NATIONALITY_ZIMBABWEAN: "Zimbabwéenne",
        },
        STUDENT_STATUS: {
            STUDENT_STATUS_PENDING: "PENDING",
            STUDENT_STATUS_CONFIRMED: "CONFIRMED",
        },
        USERTYPE: {
            USERTYPE_INTERNSHIP_COORDINATOR_TRAINER:
                "INTERNSHIP_COORDINATOR_TRAINER",
            USERTYPE_INTERNSHIP_REFERENCE_TRAINER:
                "INTERNSHIP_REFERENCE_TRAINER",
            USERTYPE_PEDAGOGICAL_REFERENCE_TRAINER:
                "PEDAGOGICAL_REFERENCE_TRAINER",
            USERTYPE_SCHOOL_DIRECTOR: "SCHOOL_DIRECTOR",
            USERTYPE_STUDENT: "STUDENT",
            USERTYPE_INTERNSHIP_COORDINATOR: "INTERNSHIP_COORDINATOR",
            USERTYPE_INTERNSHIP_SUPERVISOR: "INTERNSHIP_SUPERVISOR",
            USERTYPE_INTERNSHIP_TUTOR: "INTERNSHIP_TUTOR",
            USERTYPE_COMPANY_DIRECTOR: "COMPANY_DIRECTOR",
            USERTYPE_SCHOOL_AND_COMPANY: "SCHOOL_AND_COMPANY",
            USERTYPE_SUPER_ADMIN: "SUPER_ADMIN",
        },
    },
    Category: {
        TYPE: {
            TYPE_COMPANY: "Company",
            TYPE_SCHOOL: "School",
        },
    },
    Upload: {
        FILETYPE: {
            FILETYPE_USER_AVATAR: "USER_AVATAR",
            FILETYPE_USER_IMPORT: "USER_IMPORT",
            FILETYPE_COMPANY_POSTER: "COMPANY_POSTER",
            FILETYPE_SCHOOL_POSTER: "SCHOOL_POSTER",
            FILETYPE_MESSAGE_FILE: "MESSAGE_FILE",
            FILETYPE_COMPANY_FILE: "COMPANY_FILE",
        },
        FILETYPEINFO: {
            FILETYPEINFO_USER_AVATAR: {
                key: "USER_AVATAR",
                width: "200",
                height: "200",
                ratio: 1 / 1,
                maxSize: null,
                allowType: [".jpg", ".jpeg", ".png", ".gif", ".webp"],
                isSecure: false,
                path: "user_avatar",
            },
            FILETYPEINFO_COMPANY_POSTER: {
                key: "COMPANY_POSTER",
                width: "200",
                height: "200",
                ratio: 16 / 9,
                maxSize: null,
                allowType: [".jpg", ".jpeg", ".png", ".gif", ".webp"],
                isSecure: false,
                path: "company_poster",
            },
            FILETYPEINFO_SCHOOL_POSTER: {
                key: "SCHOOL_POSTER",
                width: "200",
                height: "200",
                ratio: 16 / 9,
                maxSize: null,
                allowType: [".jpg", ".jpeg", ".png", ".gif", ".webp"],
                isSecure: false,
                path: "school_poster",
            },
            FILETYPEINFO_USER_IMPORT: {
                key: "USER_IMPORT",
                width: null,
                height: null,
                ratio: null,
                maxSize: 20,
                allowType: [".xlsx", ".xls", ".csv"],
                isSecure: false,
                path: "user_import",
            },
            FILETYPEINFO_MESSAGE_FILE: {
                key: "MESSAGE_FILE",
                width: null,
                height: null,
                ratio: null,
                maxSize: 20,
                allowType: [],
                isSecure: true,
                path: "message_file",
            },
            FILETYPEINFO_COMPANY_FILE: {
                key: "COMPANY_FILE",
                width: null,
                height: null,
                ratio: null,
                maxSize: 20,
                allowType: [],
                isSecure: true,
                path: "company_file",
            },
        },
    },
    Partnership: {
        STATUS: {
            STATUS_PENDING: "PENDING",
            STATUS_APPROVED: "APPROVED",
            STATUS_REJECTED: "REJECTED",
        },
    },
    MessageThread: {
        TYPE: {
            TYPE_O2O: "O2O",
            TYPE_INTERNSHIP: "INTERNSHIP",
            TYPE_GROUP: "GROUP",
        },
    },
    Message: {
        STATUS: {
            STATUS_NEW: "NEW",
            STATUS_READ: "READ",
            STATUS_DELETED: "DELETED",
        },
    },
    StudentSkill: {
        RATE: {
            RATE_NOT_MOBILIZED: "NOT_MOBILIZED",
            RATE_NOT_ACQUIRED: "NOT_ACQUIRED",
            RATE_NEEDS_IMPROVEMENT: "NEEDS_IMPROVEMENT",
            RATE_ACQUIRED: "ACQUIRED",
        },
    },
};
